import React from "react";

import { getAaaGameInformationFormUrl } from "../../helpers/navigationHelpers";
import { Forms } from "../../models/programsConfig";
import { AaaApplicationStep, OnboardingProgram } from "../../models/status";
import { FormSummary } from "../FormSummary";

const formCardID = "IdXboxGameInformationFormSummary"; // TODO - change for AAA or remove

interface FormAaaGameInformationProps {
  statusMessage?: string;
}

export const FormAaaGameInformation = ({ statusMessage }: FormAaaGameInformationProps) => (
  <FormSummary
    formName={Forms.AaaGameInformation}
    getFormUrl={getAaaGameInformationFormUrl}
    formCardRule={{
      stepsToShow: new Set<AaaApplicationStep>([AaaApplicationStep.GameInformation]),
      program: OnboardingProgram.AaaProgram,
      formCardId: formCardID,
    }}
    statusMessage={statusMessage}
  />
);
